export const DEFAULT_SELECTOR_DESCRIPTION =
  'Select a community, then specify which of its competitors you want to include.';
export const FURTHER_PRICING_SELECTOR_DESCRIPTION =
  'Add communities and specify which of their care types need mystery shop data.';
export const COMPANY_PRICING_SELECTOR_DESCRIPTION =
  'Select a community, then specify which of its competitors you want to shop for.';
